// Dark/Light theme toggle — persists to localStorage, defaults to dark.
const STORAGE_KEY = "qubit-theme";
const VERSION_KEY = "qubit-theme-v";
const CURRENT_VERSION = "2";

export function setupThemeToggle() {
  const toggles = document.querySelectorAll("[data-theme-toggle]");
  if (!toggles.length) return;

  const html = document.documentElement;

  // Migration: clear stale "light" value from the earlier buggy
  // auto-detection version that read prefers-color-scheme.
  if (localStorage.getItem(VERSION_KEY) !== CURRENT_VERSION) {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.setItem(VERSION_KEY, CURRENT_VERSION);
  }

  // Default to dark (site is dark-first design).
  // Only use light if the user explicitly chose it previously.
  const stored = localStorage.getItem(STORAGE_KEY);
  const initial = stored || "dark";

  const applyTheme = (theme) => {
    if (theme === "light") {
      html.setAttribute("data-theme", "light");
    } else {
      html.removeAttribute("data-theme");
    }
    localStorage.setItem(STORAGE_KEY, theme);
    toggles.forEach((btn) => {
      btn.setAttribute("aria-pressed", theme === "light" ? "true" : "false");
      const sunIcon = btn.querySelector("[data-theme-icon-light]");
      const moonIcon = btn.querySelector("[data-theme-icon-dark]");
      if (sunIcon) sunIcon.style.display = theme === "dark" ? "none" : "";
      if (moonIcon) moonIcon.style.display = theme === "light" ? "none" : "";
    });
  };

  applyTheme(initial);

  toggles.forEach((btn) => {
    btn.addEventListener("click", () => {
      const current = html.getAttribute("data-theme") === "light" ? "light" : "dark";
      applyTheme(current === "dark" ? "light" : "dark");
    });
  });
}
